export const detectRegion = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    return tz === "Asia/Kolkata" || tz === "Asia/Calcutta" ? "in" : "intl";
  } catch {
    return "in";
  }
};

export const fmtMoney = (amount, region) =>
  region === "intl" ? `$${Number(amount).toLocaleString("en-US")}` : `₹${Number(amount).toLocaleString("en-IN")}`;

export const STATIC_PRICES = {
  in: { songs: "₹4,999", indie: "₹9,999", dropin: "₹999" },
  intl: { songs: "$49", indie: "$99", dropin: "$15" },
};

export const batchPrice = (b, region) => (region === "intl" ? b.price_usd : b.price);
export const batchDropinPrice = (b, region) => (region === "intl" ? b.dropin_price_usd : b.dropin_price);
